export const LineHeight = {
  "leading-none": "1em",
  "leading-1": "1.2em",
  "leading-2": "1.5em"
};
